import angular from 'angular';

import styles from './styles.less';

import routes from './routes';

import template from './template.html'
import controller from './controller'

export default angular.module('app.main.panel.module.areas', [])
    .config(routes)
    .component('areas', {
        template: template,
        controller: controller,
        controllerAs: 'ctrl',
    })
    .filter('trusted', ['$sce', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }])
    .name;


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/areas.component/index.js
 **/